import { defineMessages } from 'react-intl'

export default defineMessages({
  cannotDeleteFeatureTitle: {
    id: 'SpaceAppBuilderFeaturesPage.ErrorModal.cannotDeleteFeatureTitle',
    defaultMessage: 'Cannot delete feature'
  },
  cannotDeactivateFeatureTitle: {
    id: 'SpaceAppBuilderFeaturesPage.ErrorModal.cannotDeactivateFeatureTitle',
    defaultMessage: 'Cannot deactivate feature'
  },
  featureWarningSubMessage: {
    id: 'SpaceAppBuilderFeaturesPage.ErrorModal.cannotDeleteFeatureWarning',
    defaultMessage: `{featureText} within the associated app that {featureGrammar} using an App UI Notification:`
  },
  dismiss: {
    id: 'SpaceAppBuilderFeaturesPage.ErrorModal.dismiss',
    defaultMessage: 'Dismiss'
  }
})
